import { PAGE_LAYOUT_VARIANT } from 'features/App';

import SmartRate from './SmartRate';

export default [
  {
    path: '/smartrate/:venueId',
    component: SmartRate,
    pathSagas: [],
    locationSagas: [],
    pageLayout: PAGE_LAYOUT_VARIANT.WIDE,
  },
];
